import React from 'react';
import { PrinterStateData } from '../commons/Const';
import DocumasterFont from './DocumasterFont';

export type PrinterStateProps = {
    data?: any[],
    short: boolean,
    maxStates?: number,
    /** Miejsca zacięcia papieru - dopisywane do etykiety stanu "jammed" */
    jamLocations?: string[],
    /** Przyczyny wezwania serwisu - dopisywane do etykiety stanu "serviceRequested" */
    serviceCauses?: string[],
    /** Przyczyny stanu offline - dopisywane do etykiety stanu "offline" */
    offlineCauses?: string[]
}

export const PrinterState = ({short = false, entry} : {short: boolean, key: number | string, entry: any}) => {
    const key = entry.label;
    const icon = <DocumasterFont label={entry.label} key={key} style={entry.className} symbol={entry.font} />;
    if (short) return icon;
    return <span className="state" key={key}>
                <span title={entry.tooltip || ''} key={key + 's'}>{entry.label}</span>
                {icon}
            </span>;
}

/** Etykieta stanu wraz ze szczegółem z urządzenia, o ile maszyna go podała. */
const formatLabel = (key, serviceCauses, jamLocations, offlineCauses) => {
    const entry = PrinterStateData[key];
    const label = entry ? entry.label : key;
    if (key === 'serviceRequested' && serviceCauses && serviceCauses.length > 0) {
        return `${label}: ${serviceCauses.join(', ')}`;
    }
    if (key === 'jammed' && jamLocations && jamLocations.length > 0) {
        return `${label}: ${jamLocations.join(', ')}`;
    }
    if (key === 'offline' && offlineCauses && offlineCauses.length > 0) {
        return `${label}: ${offlineCauses.join(', ')}`;
    }
    return label;
}

export const PrinterStatusBadge = ({states, serviceCauses = [], jamLocations = [], offlineCauses = []}) => {

    const getAlertsLabel = (count) => {
        switch (count) {
            case 1: return 'alert';
            case 2:
            case 3:
            case 4: return 'alerty';
            default: return 'alertów';
        }
    }

    const list = states || [];
    const real = list.filter(s => s && s !== 'ok');
    if (real.length === 0) {
        return <span className="printer-status-badge ok"><span className="dot"/>OK</span>;
    }
    const isError = real.some(k => PrinterStateData[k] && PrinterStateData[k].className === 'state-error');
    const labels = real.map(k => formatLabel(k, serviceCauses, jamLocations, offlineCauses)).join(', ');
    return (
        <span className={`printer-status-badge ${isError ? 'error' : 'warn'}`} title={labels}>
            <span className="dot"/>
            {real.length === 1 ? (PrinterStateData[real[0]] ? PrinterStateData[real[0]].label : real[0]) : `${real.length} ${getAlertsLabel(real.length)}`}
        </span>
    );
}

const PrinterStates = (props: PrinterStateProps) => {
    const data = props.status || [];
    const short = props.short;
    const serviceCauses = props.serviceCauses;
    const jamLocations = props.jamLocations;
    const offlineCauses = props.offlineCauses;
    if (!data || !data.length) data.push('ok');
    if (props.maxStates && data.length > props.maxStates) {
        return <PrinterState key="notOk" short={short} entry={PrinterStateData['notOk']} />
    }
    return <div className={`status-info ${short ? 'short' : ''}`}>
        {
            data.map((key, idx)=> {
                const entry = PrinterStateData[key];
                if(entry === undefined) return null;
                // Wpisy PrinterStateData są współdzielone przez wszystkie wiersze. Zmiana etykiety
                // w miejscu wyciekłaby na pozostałe, więc szczegół niesie kopia wpisu.
                const label = formatLabel(key, serviceCauses, jamLocations, offlineCauses);
                const shown = label === entry.label ? entry : {...entry, label};
                return <PrinterState key={key} short={short} entry={shown} />
            })
        }
    </div>
}

export default PrinterStates;